export default {
  Title: 'Leads',
  Header: {
    Action: '+ Client',
    Summary: 'Last updated: #{updatedTime}',
  },
  Card: {
    Subtitles: {
      InStage: 'In stage: #{value}',
      SinceLastMsg: 'Last msg: #{value}',
    },
    SubtitleValue: {
      Day: '#{number} day',
      Days: '#{number} days',
    },
  },
  Card2: {
    Subtitles: {
      Created: 'Created',
      DaysInStage: 'Days in stage',
      Location: 'Location',
    },
    SubtitleValue: {
      NotSet: 'Not set',
    },
  },
  Filter: {
    Search: 'Search',
    SearchPlaceholder: 'Name or Contact',
    Status: 'Status',
    MoreFilters: 'More filters',
  },
  Pagination: {
    LabelDisplayedRowsNoMore: '#{from} - #{to} of #{numOfRows}',
    LabelDisplayedRowsMore: '#{from} - #{to} of more than #{numOfRows}',
  },
};
